angular.module('zc.masterApi')

.factory 'MasterAgencyUser', ($q, Api) ->
  class MasterAgencyUser
    @all: (agency_id) ->
      Api.get "/api/master/agencies/#{agency_id}/users", {}, cache: false
      .then (res) ->
        if res.data.success
          res.data.users
        else
          $q.reject res



// WEBPACK FOOTER //
// ./src/master_admin_modules/master_api/api/master_agency_user.service.coffee